export const LanguageSelector = [
  { languageFlag: "FR", languageCode: "fr" },
  { languageFlag: "GB", languageCode: "en" },
]
